import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DashboardPanelDTO, DashboardPanelUpdateDTO } from '@tempo-io/roadmap-dto';
import { toast } from '@tempo-io/sui-sonner';
import type { TempoApiError } from '@/common/api/tempoApiTypes';
import { DashboardApi } from '@/features/dashboards/api/dashboard';
import { visualizationQueryKeys } from '@/features/visualizations/queryKeys';

export const useUpdateDashboardPanelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      dashboardId,
      position,
      data,
    }: {
      dashboardId: number;
      position: number;
      data: DashboardPanelUpdateDTO;
      onMutationSuccess?: (panel: DashboardPanelDTO) => void;
      onMutationError?: (error: TempoApiError) => void;
    }) => DashboardApi.updateDashboardPanel(dashboardId, position, data),
    onSuccess: (panel, { dashboardId, onMutationSuccess }) => {
      queryClient.invalidateQueries({
        queryKey: visualizationQueryKeys.dashboard.detail(dashboardId),
      });
      queryClient.invalidateQueries({ queryKey: visualizationQueryKeys.dashboard.all() });
      onMutationSuccess?.(panel);
    },
    onError: (error: TempoApiError, { onMutationError }) => {
      onMutationError?.(error);
      toast.error(error.message ?? 'Failed to update panel');
    },
  });
};
